/* Progressive enhancement: every guide and brand anchor works without JS. */
(() => {
  const normalize = (value) => value.toLowerCase().normalize('NFKD').replace(/[^a-z0-9]/g, '');
  let dispose;

  function init() {
    if (dispose) dispose();
    const root = document.querySelector('[data-guide-controller]');
    if (!root) return;
    const scope = root.closest('main');
    if (!scope) return;
    const input = root.querySelector('[data-guide-search]');
    const filters = [...root.querySelectorAll('[data-guide-filter]')];
    const groups = [...scope.querySelectorAll('[data-guide-group]')];
    const items = [...scope.querySelectorAll('[data-guide-item]')];
    const result = root.querySelector('[data-guide-results]');
    const empty = root.querySelector('[data-guide-empty]');
    const signalController = new AbortController();
    const options = { signal: signalController.signal };
    dispose = () => signalController.abort();
    const names = new Map(items.map(item => [item, normalize(item.dataset.guideName)]));
    const aliases = { nikkon: 'nikon', cannon: 'canon' };
    let brand = 'all';

    function render() {
      const terms = input.value.trim().split(/\s+/).map(normalize).filter(Boolean);
      let total = 0;
      for (const group of groups) {
        let count = 0;
        for (const item of group.querySelectorAll('[data-guide-item]')) {
          const matches = (brand === 'all' || brand === group.dataset.guideGroup) && terms.every(term => names.get(item).includes(term));
          item.hidden = !matches;
          if (matches) count++;
        }
        group.hidden = count === 0;
        group.querySelector('[data-guide-group-count]').textContent = `${count} ${count === 1 ? 'model' : 'models'}`;
        total += count;
      }
      for (const filter of filters) {
        if (filter.dataset.guideFilter === brand) filter.setAttribute('aria-current', 'true');
        else filter.removeAttribute('aria-current');
      }
      result.textContent = `${total} ${total === 1 ? 'model' : 'models'}${brand !== 'all' || terms.length ? ` of ${items.length}` : ' listed'}`;
      empty.hidden = total !== 0;
    }

    function fromHash() {
      const hash = window.location.hash.slice(1);
      const value = aliases[hash] || hash;
      brand = filters.some(filter => filter.dataset.guideFilter === value) ? value : 'all';
      render();
    }

    for (const filter of filters) {
      filter.addEventListener('click', event => {
        event.preventDefault();
        brand = filter.dataset.guideFilter;
        history.replaceState(null, '', filter.getAttribute('href'));
        render();
      }, options);
    }
    for (const reset of scope.querySelectorAll('[data-guide-reset]')) {
      reset.addEventListener('click', event => {
        event.preventDefault();
        brand = 'all';
        input.value = '';
        history.replaceState(null, '', '#guide-library');
        render();
        input.focus({ preventScroll: true });
        root.scrollIntoView({ block: 'start' });
      }, options);
    }
    input.addEventListener('input', render, options);
    window.addEventListener('hashchange', fromHash, options);
    root.querySelector('[data-guide-search-wrap]').hidden = false;
    result.hidden = false;
    fromHash();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', init);
})();
